// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__3qQnZ","error":"InputSecondary_error__2h0q0","disabled":"InputSecondary_disabled__79wsg"};